// Animation utilities for Meeting components
import { useSpring } from 'react-spring';
import { useEffect, useState } from 'react';

/**
 * Custom hook for motion participant animation
 * @param {Object} params - Animation parameters
 * @returns {Object} Animated properties
 */
export const useMotionParticipantAnimation = ({
  relativeTop,
  relativeLeft,
  relativeHeight,
  relativeWidth,
  mounted,
  animationsEnabled
}) => {
  const animeConfig = { tension: 180, friction: 22 };

  const calculateScale = () => {
    if (mounted) return 1;
    return animationsEnabled ? 0 : 0.5;
  };

  return useSpring({
    top: relativeTop,
    left: relativeLeft,
    height: relativeHeight,
    width: relativeWidth,
    scale: calculateScale(),
    config: animeConfig,
  });
};

/**
 * Custom hook for mount/unmount animation state
 * @returns {boolean} Mounted state
 */
export const useMountAnimation = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 100);

    return () => {
      clearTimeout(timer);
      setTimeout(() => setMounted(false), 100);
    };
  }, []);

  return mounted;
};

/**
 * Get animation duration based on enabled state
 * @param {boolean} animationsEnabled - Whether animations are enabled
 * @param {number} baseDuration - Base duration in ms
 * @returns {number} Calculated duration
 */
export const getAnimationDuration = (animationsEnabled, baseDuration = 800) => {
  return baseDuration * (animationsEnabled ? 1 : 0.5);
};
